import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-published-community.tsx
/**
* icon.24.published.community
*
* Please use the icon badge wrapper component instead.
*
* Keywords: package, checkmark, verified, delivery, shipping, confirmation, parcel, approved
*
* @deprecated
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjUyMyA5LjIxYTEgMSAwIDAgMSAxLjQ3Ny44OHYxLjE2N2E0LjUgNC41IDAgMCAwLTEtLjIyOXYtLjkzOGwtNS4wMDEgMi43MDd2NC44NjNsLjQzMy0uMjM1cS4yMTcuNDU4LjUyOC44NTFsLTEuMjIzLjY2M2EuNS41IDAgMCAxLS40NzYgMGwtNS40NzYtMi45NjVBMS41IDEuNSAwIDAgMSA1IDE0LjY1NFYxMC4wOWExIDEgMCAwIDEgMS40NzctLjg4bDUuMDIzIDIuNzJ6TTE2LjUgMTJhMy41IDMuNSAwIDEgMSAwIDcgMy41IDMuNSAwIDAgMSAwLTdtMCAxYTIuNSAyLjUgMCAxIDAgMCA1IDIuNSAyLjUgMCAwIDAgMC01TTYgMTQuNjU0YS41LjUgMCAwIDAgLjI2Mi40NGw0LjczNyAyLjU2NnYtNC44NjNMNiAxMC4wOXptMTEuMDUzLS4zNzhhLjUuNSAwIDAgMSAuODk0LjQ0OGwtMSAyYS41LjUgMCAwIDEtLjguMTNsLTEtMWEuNS41IDAgMSAxIC43MDctLjcwN2wuNTA4LjUwOHpNMTEuNSA1YTIuNSAyLjUgMCAxIDEtLjAwMiA1LjAwMkEyLjUgMi41IDAgMCAxIDExLjUwMSA1bTAgMWExLjUgMS41IDAgMSAwIDAgMyAxLjUgMS41IDAgMCAwIDAtMyIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2269
*/
const Icon24PublishedCommunity = memo(function Icon24PublishedCommunity(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.523 9.21a1 1 0 0 1 1.477.88v1.167a4.5 4.5 0 0 0-1-.229v-.938l-5.001 2.707v4.863l.433-.235q.217.458.528.851l-1.223.663a.5.5 0 0 1-.476 0l-5.476-2.965A1.5 1.5 0 0 1 5 14.654V10.09a1 1 0 0 1 1.477-.88l5.023 2.72zM16.5 12a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M6 14.654a.5.5 0 0 0 .262.44l4.737 2.566v-4.863L6 10.09zm11.053-.378a.5.5 0 0 1 .894.448l-1 2a.5.5 0 0 1-.8.13l-1-1a.5.5 0 1 1 .707-.707l.508.508zM11.5 5a2.5 2.5 0 1 1-.002 5.002A2.5 2.5 0 0 1 11.501 5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
		})
	});
});
//#endregion
export { Icon24PublishedCommunity };

//# sourceMappingURL=icon-24-published-community.js.map